import { render } from "./WagerRewardsPage.vue?vue&type=template&id=1dfad1e7"
import script from "./WagerRewardsPage.vue?vue&type=script&lang=js"
export * from "./WagerRewardsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__